// extracted by mini-css-extract-plugin
export default {"productCallout":"Xba-z"};